import React from 'react'
import { Box, createStyles, Text } from '@mantine/core'

const useStyles = createStyles((theme) => ({
	context: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing.md,
		minWidth: 0,
		[theme.fn.smallerThan('sm')]: {
			display: 'grid',
			gridTemplateColumns: 'minmax(0, 1fr)',
			rowGap: 2,
		},
	},
	organization: {
		display: 'flex',
		alignItems: 'center',
		minWidth: 0,
		maxWidth: '40%',
		[theme.fn.smallerThan('sm')]: { display: 'contents' },
	},
	organizationName: {
		color: theme.colorScheme === 'dark' ? theme.colors.gray[4] : theme.colors.gray[7],
		fontSize: theme.fontSizes.sm,
		fontWeight: 500,
		minWidth: 0,
		overflowWrap: 'anywhere',
		[theme.fn.smallerThan('sm')]: {
			gridColumn: 1,
			gridRow: 1,
			fontSize: theme.fontSizes.xs,
		},
	},
	separator: {
		color: theme.colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[4],
		fontSize: 22,
		flexShrink: 0,
		[theme.fn.smallerThan('sm')]: { display: 'none' },
	},
	scope: {
		fontSize: theme.fontSizes.sm,
		fontWeight: 600,
		minWidth: 0,
		overflowWrap: 'anywhere',
		[theme.fn.smallerThan('sm')]: { gridColumn: 1, gridRow: 2 },
	},
}))

const WorkspaceContext = ({ context }) => {
	const { classes } = useStyles()
	const { organizationName, scopeName, scopeKind } = context
	const organizationLabel = scopeKind === 'account' || scopeKind === 'control'
		? 'Workspace'
		: 'Organization'

	return (
		<Box className={classes.context}>
			<Box
				className={classes.organization}
				role='group'
				aria-label={`${organizationLabel}: ${organizationName}`}
			>
				<Text component='span' className={classes.organizationName}>
					{organizationName}
				</Text>
			</Box>
			<Text component='span' className={classes.separator} aria-hidden='true'>/</Text>
			<Text
				component='span'
				className={classes.scope}
				role='group'
				aria-label={scopeKind === 'experience' ? `Experience: ${scopeName}` : scopeName}
			>
				{scopeName}
			</Text>
		</Box>
	)
}

export default WorkspaceContext
